require( 'script-loader!../../../node_modules/parallax-imagescroll/jquery.imageScroll.min' );